import React from 'react';
import './Button.css';

function Button({ children, onClick, type = "button", variant = "neutral", as = "button", placeholder, value, onChange, onFocus, name, disabled, style }) {
  
  const className = variant === "neutral" ? "btn-neutral" : "btn-cta";
  
  if (as === "input") {
    return (
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        name={name}
        className={className}
        style={style}
      />
    );
  }
  
  return (
    <button
      type={type}
      onClick={onClick}
      className={className}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
}

export default Button;
